(() => {
  if (window.scCartFlightInstalled) return;
  window.scCartFlightInstalled = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new WeakMap();
  const flights = new Set();
  const pulses = new Set();
  const duration = 900;
  const visible = (el) => {
    if (!el || !el.isConnected) return false;
    const r = el.getBoundingClientRect();
    const css = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth && css.visibility !== 'hidden' && css.display !== 'none' && Number(css.opacity) > 0;
  };
  const target = () => Array.from(document.querySelectorAll('#SiteHeader [data-cart-drawer-toggle], .header-group [data-cart-drawer-toggle], header a[href$="/cart"]')).find(visible);
  const fallbackTarget = () => {
    const original = document.querySelector('#SiteHeader [data-cart-drawer-toggle] svg');
    if (!original) return null;
    const marker = document.createElement('span');
    marker.setAttribute('aria-hidden', 'true');
    marker.setAttribute('data-sc-cart-flight-target', '');
    marker.style.cssText = 'position:fixed;right:16px;top:16px;width:46px;height:46px;display:grid;place-items:center;background:#fff;color:#111;border:1px solid #d7dbd0;border-radius:6px;box-shadow:0 2px 12px #0001;pointer-events:none;z-index:2147483001;';
    const icon = original.cloneNode(true);
    icon.style.cssText = 'width:26px;height:26px;display:block;color:#111;fill:none;stroke-width:2px;';
    marker.append(icon);
    document.body.append(marker);
    return marker;
  };
  const retire = (cart) => {
    if (cart?.hasAttribute('data-sc-cart-flight-target')) setTimeout(() => cart.remove(), 400);
  };
  const pulse = (el) => {
    const icon = el?.querySelector('svg') || el;
    if (!icon || !visible(icon) || reduced.matches || !icon.animate) return;
    const a = icon.animate([
      {transform: 'translateY(0) scale(1)'},
      {transform: 'translateY(-5px) scale(1.1)', offset: 0.35},
      {transform: 'translateY(1px) scale(.97)', offset: 0.75},
      {transform: 'translateY(0) scale(1)'}
    ], {duration: 320, easing: 'ease-out'});
    pulses.add(a);
    a.finished.catch(() => {}).finally(() => pulses.delete(a));
  };
  const remember = (source) => {
    if (!source || reduced.matches || document.hidden) return;
    const previous = pending.get(source);
    if (previous) clearTimeout(previous.timer);
    const context = source.closest('product-info, [data-product-block], .product-grid-item, [data-product]') || source;
    const selectors = '.product__slide.is-selected img, .product__slide:not(.media--hidden) img, .product-grid-item__image img, [data-product-media-container] img, .popup-quick-view__gallery img, .product__media img, .product__slides img';
    let images = Array.from(context.querySelectorAll(selectors)).filter(visible);
    if (!images.length) images = Array.from(context.querySelectorAll('img')).filter(visible);
    const image = images.find(i => i.complete && i.naturalWidth > 0);
    const button = source.submitButton || source.querySelector('[type="submit"], [data-add-to-cart]');
    const origin = image || (visible(button) ? button : null);
    if (!origin) return;
    const r = origin.getBoundingClientRect();
    const data = {
      src: image?.currentSrc || image?.src || '',
      rect: {left: r.left, top: r.top, width: r.width, height: r.height},
      scrollX: window.scrollX,
      scrollY: window.scrollY,
      timer: setTimeout(() => pending.delete(source), 60000)
    };
    pending.set(source, data);
  };
  const finish = (source, item) => {
    const data = pending.get(source);
    if (data) {clearTimeout(data.timer); pending.delete(source);}
    if (reduced.matches || document.hidden) return;
    const cart = target() || (data ? fallbackTarget() : null);
    if (!cart) return;
    if (!data || flights.size >= 4) {pulse(cart); retire(cart); return;}
    const src = data.src || item?.image || item?.featured_image?.url || item?.featured_image?.src;
    if (!src) {pulse(cart); retire(cart); return;}
    const endpoint = cart.querySelector('svg') || cart;
    const end = endpoint.getBoundingClientRect();
    const start = data.rect;
    const size = Math.min(140, Math.max(80, start.width * .6));
    const sx = start.left + data.scrollX - window.scrollX + start.width / 2 - size / 2;
    const sy = start.top + data.scrollY - window.scrollY + start.height / 2 - size / 2;
    if (sy + size < 0 || sy > innerHeight || sx + size < 0 || sx > innerWidth) {pulse(cart); retire(cart); return;}
    const ex = end.left + end.width / 2 - size / 2;
    const ey = end.top + end.height / 2 - size / 2;
    const cx = sx + (ex - sx) * .42;
    const cy = Math.max(14, Math.min(sy, ey) - 95);
    const ghost = document.createElement('img');
    ghost.src = src;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.setAttribute('data-sc-cart-flight', '');
    ghost.style.cssText = `position:fixed;left:0;top:0;width:${size}px;height:${size}px;max-width:none;max-height:none;object-fit:contain;pointer-events:none;z-index:2147483000;margin:0;padding:0;border:0;transform-origin:center;will-change:transform,opacity;filter:drop-shadow(0 5px 5px #0002);`;
    const frames = Array.from({length: 61}, (_, i) => {
      const t = i / 60;
      const x = (1-t)*(1-t)*sx + 2*(1-t)*t*cx + t*t*ex;
      const y = (1-t)*(1-t)*sy + 2*(1-t)*t*cy + t*t*ey;
      return {offset: t, transform: `translate(${x}px,${y}px) scale(${1-.88*t*t}) rotate(${-10*Math.sin(Math.PI*t)}deg)`, opacity: t < .88 ? 1 : Math.max(0, (1-t)/.12)};
    });
    document.body.append(ghost);
    if (!ghost.animate) {ghost.remove(); pulse(cart); retire(cart); return;}
    let a;
    try {a = ghost.animate(frames, {duration, easing:'cubic-bezier(.25,.05,.35,1)', fill:'forwards'});}
    catch {ghost.remove(); retire(cart); return;}
    const entry = {ghost, animation:a, cart};
    flights.add(entry);
    a.finished.then(() => pulse(target() || cart)).catch(() => {}).finally(() => {
      ghost.remove(); a.cancel(); flights.delete(entry); retire(cart);
    });
  };
  document.addEventListener('sc:cart-flight:start', event => {
    try {remember(event.detail?.source);} catch {}
  });
  document.addEventListener('sc:cart-flight:success', event => {
    try {finish(event.detail?.source, event.detail?.item);} catch {}
  });
  const clean = () => {
    flights.forEach(({ghost, animation, cart}) => {animation.cancel(); ghost.remove(); if (cart?.hasAttribute('data-sc-cart-flight-target')) cart.remove();});
    flights.clear();
    pulses.forEach(a => a.cancel()); pulses.clear();
  };
  reduced.addEventListener('change', event => {if (event.matches) clean();});
  document.addEventListener('visibilitychange', () => {if (document.hidden) clean();});
  window.addEventListener('pagehide', clean);
})();